import Ajax from "../components/Ajax";
import Lazy from "../components/Lazy";

const ID_LOAD_BUTTON = '#load-news';
const ID_NEWS_CONTAINER = '#news-grid';

let loadButtonEl: HTMLElement;
let obj: Newspagination;
let ajax: Ajax;
let lazy: Lazy;

export default class Newspagination {

    constructor(ajaxObj: Ajax) {
        ajax = ajaxObj;
        loadButtonEl = document.querySelector(ID_LOAD_BUTTON);
        if(loadButtonEl != null){
            this.render();
        }
        obj = this;
    }

    render() {
        loadButtonEl.addEventListener('click', this.loadNews);
    }

    loadNews(){
        //@ts-ignore
        let datapool = window.paginationParams

        let data = {
            'action': 'pagination_news',
            'query': datapool.posts,
            'page': datapool.current_page
        }

        let resp = ajax.makeRequest('POST', datapool, data, false);

        if(resp.status == 200) {
            datapool.current_page++;
            let newsHtmlString = resp.responseText;
            let newsHtmlContainer = document.querySelector(ID_NEWS_CONTAINER);


            let observer = new MutationObserver(mutationRecords => {
                lazy = new Lazy();
                lazy.loadAjaxContent();
            });
            observer.observe(newsHtmlContainer, {
              childList: true // observe direct children
            });

            newsHtmlContainer.insertAdjacentHTML('beforeend', newsHtmlString);
        }

        if(datapool.max_page <= datapool.current_page) {
           loadButtonEl.style.display = 'none';
        }

    }

}